import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { PharmacyGroup } from '../_models/pharmacy-group.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class PharmacyGroupService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getPharmacyGroupsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}&is_active=${filter.isActive}`;
    } else {
      if (filter.name) fromString += `&last_name_has=${filter.name}`;
      if (filter.email) fromString += `&email_has=${filter.email}`;
      if (filter.phone) fromString += `&phone_has=${filter.phone}`;
      if (filter.fax) fromString += `&fax_has=${filter.fax}`;
      if (filter.isActive) fromString += `&is_active=${filter.isActive}`;
    }

    return fromString;
  }
  createPharmacyGroup(_pharmacyGroup: PharmacyGroup) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<PharmacyGroup>(url, _pharmacyGroup, { headers });
  }

  findPharmacyGroups(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: PharmacyGroupService.getPharmacyGroupsListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(
      `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups`,
      { params },
    );
  }

  
  updatePharmacyGroup(_pharmacyGroup: PharmacyGroup): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${_pharmacyGroup.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<PharmacyGroup>(url, _pharmacyGroup, { headers });
  }

  deletePharmacyGroup(pharmacyGroupId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${pharmacyGroupId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  searchPharmacyGroups(term: string): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups`;
    const params = new HttpParams({ fromString: 'search_term=' + term });
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers, params });
  }
}
